export enum LabelType {
    'BARCODE' = 0,
    'BRAND' = 1,
    'FLOW' = 2,
    'UOS' = 3,
    'DOS' = 4,
    'SALE_QTY' = 5,
    'SALES' = 6,
    'AVG_PRICE' = 7,
    'DESC' = 8,
    'DESC1' = 9,
    'DESC2' = 10,
    'DESC3' = 11,
    'DESC4' = 12,
    'DESC5' = 13,
    'VAL1' = 14,
    'VAL2' = 15,
    'VAL3' = 16,
    'VAL4' = 17,
    'VAL5' = 18,
    'CAPACITY_CASEPACK' = 19
}